// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import router from './router';
import store from './store';
import Moment from 'moment';

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import './permission'

import request from "./util/request";

Vue.config.productionTip = false

Vue.prototype.request = request;

Vue.prototype.moment = Moment;

Vue.use(Element, {
  size: 'medium' // set element-ui default size 
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js